import { createEvent } from '@cobuildlab/react-simple-state';

export const isTourOpenEvent = createEvent(false);
export const reportsTourSelectedTabEvent = createEvent(null);
export const lprDashboardTourMapOptionEvent = createEvent(null);
export const lprDashboardTourGraphOptionEvent = createEvent(null);
export const basicDashboardTourRepoViewTabEvent = createEvent(null);
